import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import React, { useState } from 'react';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';

const ChatbotHeader = ({ title, onExit }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flex: 3,
      }}
      className="custom-headeer"
    >
      <h6 style={{marginTop:'6px'}}>{title}</h6>
      <Button size="small" onClick={() => setShowConfirmDialog(true)} sx={{ position: 'absolute', right: '5px' }}>
        <CloseIcon />
      </Button>
      {showConfirmDialog && (
        <>
          <Dialog open={showConfirmDialog} maxWidth="xs" fullWidth>
            <DialogContent>Would you like to end this chat session?</DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                onClick={() => {
                  setShowConfirmDialog(false);
                  onExit();
                }}
              >
                Yes
              </Button>
              <Button variant="contained" onClick={() => setShowConfirmDialog(false)}>
                No
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </div>
  );
};

export default ChatbotHeader;
